import { FC } from 'react';
import { Typography } from 'antd';
import styles from '../index.module.less';
const defaultAssets = require('@/assets/images/default-photo.png');
const { Text } = Typography;

const HeaderUserInfo:FC<any> = ({
  tenantName,
  name,
  avatar
}) => {
  return (
    <div className={styles.headerUserInfo} onClick={(e) => e.stopPropagation()}>
      <div className={styles.headerUserInfoName || '-'}>{name}</div>
      <Text
        style={{ width: 120 }}
        ellipsis={{ tooltip: tenantName }}>
        <span className={styles.headerUserInfoTenantName}>
          {tenantName}
        </span>
      </Text>
      <img className={styles.headerUserInfoImg} src={avatar || defaultAssets} alt='' />
    </div>
  );
};
export default HeaderUserInfo;
